<template>
  <div v-html="privacyform.content">
      
  </div>
</template>

<script>
import { getPricacy } from '@/api/activity'
export default {
    data () {
        return {
            privacyform: {}
        }
    },
    mounted() {
        this.getPricacyList()
    },
    activated () {
        this.getPricacyList()
    },
    methods: {
        // 获取隐私条款
        getPricacyList () {
            getPricacy().then(res => {
                this.privacyform = res.data
            })
        },
    }
}
</script>

<style>

</style>